import { Box, Text, Divider, Pagination, Stack } from 'braid-design-system';
import { Fragment } from 'react';

import type { ProfileCardView } from '../../types/profile.types';
import type { LoginPromptProps } from '../GenericLoginPrompt/GenericLoginPrompt';
import { ProfileCard } from '../Profile/ProfileCard/ProfileCard';

import { countTextWrapperStyle } from './ProfileList.css';

interface Props {
  profiles: ProfileCardView[];
  isAuthenticated: boolean;
  countText: string;
  loginUrl: string;
  bottomActionBanner?: React.ReactNode;
  paginationProps?: React.ComponentProps<typeof Pagination>;
  renderNoResults?: () => React.ReactNode;
  onProfileClick?: (profileSlug: string) => void;
  trackingCallbacks: LoginPromptProps['trackingCallbacks'];
  getProfileViewLink: (profile: ProfileCardView) => string;
  onLastInteractionClick?: (profileSlug: string) => void;
}

export const ProfileList = ({
  profiles,
  countText,
  isAuthenticated,
  loginUrl,
  bottomActionBanner,
  paginationProps,
  renderNoResults,
  onProfileClick,
  trackingCallbacks,
  getProfileViewLink,
  onLastInteractionClick,
}: Props) => {
  const hasProfiles = profiles.length > 0;

  return (
    <>
      <Box
        paddingX="medium"
        display="flex"
        alignItems="center"
        paddingY="medium"
        className={countTextWrapperStyle}
      >
        <Text size="small" weight="strong">
          {countText}
        </Text>
      </Box>

      {hasProfiles ? (
        <Stack space="none">
          {profiles.map((profile, index) => (
            <Fragment key={profile.slug}>
              <ProfileCard
                profile={profile}
                isAuthenticated={isAuthenticated}
                loginUrl={loginUrl}
                profileViewLink={getProfileViewLink(profile)}
                onProfileClick={onProfileClick}
                trackingCallbacks={trackingCallbacks}
                onLastInteractionClick={onLastInteractionClick}
              />

              {index < profiles.length - 1 && <Divider />}
            </Fragment>
          ))}
        </Stack>
      ) : (
        renderNoResults?.()
      )}

      {bottomActionBanner && (
        <>
          <Divider />
          {bottomActionBanner}
        </>
      )}

      {paginationProps && (
        <>
          <Divider />
          <Box paddingY="small">
            <Pagination {...paginationProps} />
          </Box>
        </>
      )}
    </>
  );
};
